import React from 'react';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { trakrefFontFamily } from '../utils';
import UserInfo from '../UserInfo';

const AccountMenuButton = ({
    icon,
    title,
    description,
    onClick,
}) => (
    <ListItem
        key={title}
        sx={
            UserInfo.isProduction
                ? {}
                : {
                    paddingTop: 0,
                    paddingBottom: 0
                }
        }
    >
        <ListItemButton onClick={onClick}
            sx={{
                border: { xs: '1px solid #0000001F' },
            }}
        >
            <ListItemIcon className='rightSideNavIcon' sx={{
                       pr: { xs: 2, md: 0 },
                }}>
                <img
                    src={icon}
                    width={30}
                    height={30}
                    viewBox={"0 0 30 30"}
                    alt={title}
                />
            </ListItemIcon>
            <ListItemText
                primary={title}
                secondary={description}
                secondaryTypographyProps={{ fontFamily: trakrefFontFamily }}
            />
        </ListItemButton>
    </ListItem>
);

export default AccountMenuButton;
